/*
 * @Author: 张玉婷
 * @Date: 2022-07-15 09:29:00
 * @LastEditTime: 2025-06-17 13:15:13
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description:
 * @FilePath: \web\src\config\index.js
 */
const ip = '';

export const serveIp = `${ip}/mine`;
// export const imageIp = 'http://10.254.244.202:8365/'; // 公司本地
// export const imageIp = 'http://10.254.240.202:8365/'; // 公司本地
// export const imageIp = 'https://kyy.zgkyb.com'; // 客户
export const imageIp = window.location.origin; // 客户
// export const fileBaseUrl = ''//import.meta.env.FILE_BASE_URL; // 客户
